module.exports = __webpack_public_path__ + "img/sobre_cultura_bento_capela_04.ba67509d.png";